import styled from 'styled-components'



export const MainContainer = styled.div`   
    margin-top: 77px;

`

export const DetailContainer = styled.div`
max-width: 100%;

img{
    width: auto;
    width: 100%;
    object-fit: contain;
}

p{
    font-size: 35px;
    font-weight: 600;
    text-shadow: 2px 2px grey;
    color: white;
    position: absolute;
    top:40vh;
    text-align: center;
    display: flex;
    width: 100%;
    justify-content: center;
    
}

`